export const typographyPxSizes = {
  size: {
    display: '96px',
    h1: '72px',
    h2: '64px',
    h3: '48px',
    h4: '36px',
    h5: '30px',
    h6: '24px',
    pL: '20px',
    pM: '18px',
    pS: '16px',
    captionL: '14px',
    captionM: '12px',
    captionS: '10px',
  },

  lineHeight: {
    display: '100px',
    h1: '80px',
    h2: '72px',
    h3: '56px',
    h4: '44px',
    h5: '36px',
    h6: '32px',
    pL: '28px',
    pM: '26px',
    pS: '24px',
    captionL: '20px',
    captionM: '16px',
    captionS: '14px',
    captionXS: '12px',
  },

  letterSpacing: {
    display: '-3.6px',
    h1: '-2.208px',
    h2: '-1.696px',
    h3: '-1.008px',
    h4: '-0.704px',
    h5: '-0.496px',
    h6: '-0.304px',
    pL: '-0.208px',
    pM: '-0.208px',
    pS: '-0.208px',
    captionL: '-0.096px',
    captionM: '0px',
    captionS: '0px',
  },
}
